import styled from "styled-components";

const TableContainer = styled.div`
  padding: 20px;
  overflow-y: scroll;
  .ant-table-content {
    overflow-x: scroll;
  }
  .ant-table-thead .ant-table-cell {
    background-color: white;
    color: #8c8c8c;
    font-weight: 600;
  }
`;

export { TableContainer };
